import React from 'react';
import { useAuth } from '../../../../auth';
import { SiteLink, useRouter } from '../../../../components';
import { useGet } from '../../../../components';
import env from '../../../../env';
import { getAuthErrorMessage } from '../../../../utils/authErrorMessages';
// import { useUsers } from '../../users/users';

export function Login(props) {
  const [username, setUsername] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [error, setError] = React.useState("");
  const [pending, setPending] = React.useState(false);
  const [agreed, setAgreed] = React.useState(false);
  const auth = useAuth();

  const router = useRouter();

  const get = useGet();

  React.useEffect(() => {
    get.send(env.apiBase + '/api/users/getusers');
    // eslint-disable-next-line
  }, []);
  
  const users = get.response;

  function submit(e) {
    setPending(true);
    //console.log('loggin', username, password)
    e.preventDefault();
    e.stopPropagation();
    setPending(true);

    auth.signin(username, password).then(firebaseUser => {
      // console.log("USER",firebaseUser)
      setPending(false);
      setError('')
      
      // Find the user in the API data that matches the Firebase user's email
      if (Array.isArray(users)) {
        const apiUser = users.find(user => user.email === firebaseUser.email);
        
        if (apiUser) {
          // Route based on the API user's member type
          switch (apiUser.memberType) {
            case 0:
              router.push('/dashboard');
              break;
            case 1:
              router.push('/members/entered-apprentice');
              break;
            case 2:
              router.push('/members/fellow-craft');
              break;
            case 3:
              router.push('/members/master-mason');
              break;
            case 18:
              router.push('/members/rose-croix');
              break;
            case 30:
              router.push('/members/knights-kadosh');
              break;
            case 31:
              router.push('/members/tribunal-of-courage');
              break;
            case 32:
              router.push('/members/consistory');
              break;
            case 33:
              router.push('/members/baringa-triangle');
              break;
            default:
              router.push('/dashboard');
              break;
          }
        } else {
          // User not found in API data, redirect to default member page
          router.push('/members/login');
        }
      } else {
        // Users data not loaded yet, redirect to default member page
        router.push('/members/login');
      }
    }).catch(error => {
      setPending(false);
      setError(getAuthErrorMessage(error));
    })

  }
  return (
    <div className="sign-in auth-panel"  style={{maxWidth: '600px', margin: 'auto'}}>
      <h1>Log In</h1>
      <div className="loading-panel-holder" >
        {/* <app-loading [loadingStatus]="loadingStatus"></app-loading> */}
        <div className="panel-content">
          <form method="POST" noValidate="" onSubmit={submit}>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input id="email" type="email" className="form-control" name="email" required autoFocus
                onChange={event => {
                  setUsername(event.target.value);
                }} />
              <div className="invalid-feedback">
                Email is invalid
          </div>
            </div>

            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input id="password" type="password" className="form-control" name="password" required
                onChange={event => {
                  setPassword(event.target.value);
                }} />
              <div className="invalid-feedback">
                Password is required
          </div>
            </div>
            {/* 
        <!-- <div className="form-group">
                  <div className="custom-checkbox custom-control">
            <input type="checkbox" name="remember" id="remember" className="custom-control-input" #remember>
                    <label for="remember" className="custom-control-label">Remeber Me</label>
                  </div>
        </div> --> */}

            <div className="form-group">
              <div className='form-check'>
                <input type="checkbox" name="privacy" id="privacy" className="form-check-input" checked={agreed} onChange={(e) => setAgreed(e.target.checked)} required />
                <label htmlFor="remember" className="custom-control-label">
                  I agree to the <SiteLink to="/members-privacy">Privacy and Confidentiality Policy</SiteLink>
                </label>
              </div>
            </div>

            <div className="form-group m-0">
              <button type="submit" disabled={pending} className="btn btn-primary btn-block">
                {pending && <span className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>}
                <span className="">Log In</span>
              </button>
            </div>

            {error && <div className="alert alert-danger mt-3" role="alert">{error}</div>}

            {/* <div className="form-group m-0">
          <button [disabled]="submitting" type="submit" className="btn btn-primary btn-block">
            <span *ngIf="submitting" className="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
            <span className="">Log In</span>
          </button>
        </div> */}

          </form>

          {/* <div className="social-logins">
        <span className="or">Or Log in with </span>
        <div className="form-group">
          <button type="button" className="btn btn-dark" (click)="googleAuth()">
            Google
          </button>
        </div>
      </div>

      <div>
        <a [routerLink]="AUTH_URLS.forgotPasswordUrl">
          Forgot Password?
        </a>
      </div>
      <div className="">
        Don't have an account? <a [routerLink]="AUTH_URLS.signUpUrl">Sign Up</a>
      </div> */}
        </div>
      </div>
    </div>)
}